import ContactForm from '@/components/ContactForm';
import MetaTags from '@/components/MetaTags';
import { CLIENTS } from '@/constants/clients';
import { PAGE_META_DATA } from '@/constants/constants';
import content from '@/constants/landing-content';

function Contact() {
  return (
    <div className='h-full'>
      <MetaTags title={PAGE_META_DATA.landing.title} description={PAGE_META_DATA.landing.description} />

      <section className='h-full py-8 pb-10 md:py-[34px] md:pb-[46px]'>
        <div className='flex flex-col h-full gap-6 md:gap-12 px-4 mx-auto md:container md:grid md:grid-cols-2'>
          <header className='pb-4 md:py-6 md:pt-4'>
            <h1 className='font-extrabold text-3xl/8 tracking-tight m-0 mb-[5px]'>Contact Us</h1>
            <p className='text-[#525252] tracking-tight text-[1.125rem]/[1.35rem] pb-6 border-b border-b-gray-200'>
              Fill out the form and a member of our team will be in contact with you.
            </p>

            <div className='mt-7 md:mt-8'>
              <p className='mb-5 text-[#525252] tracking-tight text-[1rem]/[1.25rem] md:mb-6'>
                {content.clientsSection.description}
              </p>
              <div className='flex gap-5 gap-y-4 flex-wrap'>
                {CLIENTS.map((client, index) => (
                  <img
                    key={index}
                    src={client.logo}
                    alt={client.name}
                    className='color-logo-to-grey h-[28px] md:h-[34px] w-auto'
                  />
                ))}
              </div>
            </div>
          </header>

          <main className='py-5 md:py-7 px-7 border border-gray-200 rounded-md'>
            <ContactForm />
          </main>
        </div>
      </section>
    </div>
  );
}

export default Contact;
